import React from 'react';
import { Box, TextField, Button, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({
  searchInput,
  onSearchInputChange,
  onSearch,
  placeholder = 'Search leads...',
  disabled = false,
  sx = {},
}) => (
  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap', ...sx }}>
    <TextField
      size="small"
      placeholder={placeholder}
      value={searchInput}
      onChange={onSearchInputChange}
      onKeyDown={(e) => e.key === 'Enter' && onSearch?.()}
      disabled={disabled}
      sx={{ minWidth: 260 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        ),
      }}
    />
    <Button variant="outlined" onClick={onSearch} disabled={disabled}>
      Search
    </Button>
  </Box>
);

export default SearchBar;
